import {extendVariants, Input} from "@heroui/react";

const PInput = extendVariants(Input, {
    defaultVariants: {
        radius:         "sm",
        labelPlacement: "outside-top",
    },
});

export default PInput;
